import {
    Box,
    Button,
    Typography,
} from '@mui/material'
import FindIdealBG from '../../../assets/app/home/home_find_ideal_bg.png'
import { MOTORLOAN_LINK } from '../../../common/config'
import { useTranslation } from 'react-i18next'

export const SMAppHomeFindIdeal: React.FC = () => {
    const { t } = useTranslation()
    
    // 打开motorloan
    const goToMotorloan = () => {
        window.open(MOTORLOAN_LINK)
    }
    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                alignContent: 'center',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundImage: `url(${FindIdealBG})`,
                paddingTop: '100px',
                paddingBottom: '160px',
            }}
        >
            <Box>
                <Typography fontWeight={700} fontSize={'24px'} color={'#141F39'} textAlign={'center'} paddingLeft={'16px'} paddingRight={'16px'} paddingTop={'60px'}>
                    {t('t72')}
                </Typography>

                <Typography paddingTop={'15px'} fontWeight={400} fontSize={'14px'} color={'#6B6B6B'} textAlign={'center'} paddingLeft={'16px'} paddingRight={'16px'}>
                    {t('t73')}
                </Typography>
            </Box>
            <Box>    
            <Button onClick={goToMotorloan}
                variant='contained'
                fullWidth
                sx={{
                    borderRadius: '30px',
                    mt: 4,
                    bgcolor: '#FFC107',
                    color: '#141F39',
                    fontSize: '14px',
                    fontWeight: 700,
                    '&:hover': {
                        bgcolor: '#FFC107',
                    },
                    height: '48px',
                    textTransform: 'none',
                }}
                >
                {t('t74')}
            </Button>
             
            </Box>
        </Box>
    )
}

// ======================= EXPORT
export default SMAppHomeFindIdeal
